export function mergeModelSpecMaps(
  maps: Array<Record<string, Record<string, unknown>> | undefined>
): Record<string, Record<string, unknown>> {
  return maps.reduce<Record<string, Record<string, unknown>>>(
    (merged, map) => (map ? { ...merged, ...map } : merged),
    {}
  );
}

export function attachedModelSpecs(
  modelSpecs: Record<string, Record<string, unknown>> | undefined
): { modelSpecs?: Record<string, Record<string, unknown>> } {
  if (!modelSpecs || Object.keys(modelSpecs).length === 0) return {};
  return { modelSpecs };
}
